import { render, staticRenderFns } from "./previewdialog.vue?vue&type=template&id=3c5b103c&scoped=true"
import script from "./previewdialog.vue?vue&type=script&lang=js"
export * from "./previewdialog.vue?vue&type=script&lang=js"
import style0 from "./previewdialog.vue?vue&type=style&index=0&id=3c5b103c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../../../../../../../opt/build-cache/yunying/node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c5b103c",
  null
  
)

export default component.exports